import { useMemo } from "react";
import classNames from "classnames";

import AscActivityCrossword from "../AscAddActivitiesVariants/AscActivityCrossword/AscActivityCrossword";
import AscActivityDragDrop from "../AscAddActivitiesVariants/AscActivityDragDrop/AscActivityDragDrop";
import AscActivityDragWord from "../AscAddActivitiesVariants/AscActivityDragWord/AscActivityDragWord";
import AscActivityFindWords from "../AscAddActivitiesVariants/AscActivityFindwords/AscActivityFindwords";
import AscActivityFlashcards from "../AscAddActivitiesVariants/AscActivityFlashcards/AscActivityFlashcards";
import AscActivityQuiz from "../AscAddActivitiesVariants/AscActivityQuiz/AscActivityQuiz";
import AscActivityTimeline from "../AscAddActivitiesVariants/AscActivityTimeline/AscActivityTimeline";
import AscActivityTrueFalse from "../AscAddActivitiesVariants/AscActivityTrueFalse/AscActivityTrueFalse";
import AscActivityEssay from "../AscAddActivitiesVariants/AscActivityEssay/AscActivityEssay";
import AscActivityMarkWord from "../AscAddActivitiesVariants/AscActivityMarkWord/AscActivityMarkWord";
import AscActivityAssessment from "../AscAddActivitiesVariants/AscActivityAssessment/AscActivityAssessment";
import AscActivityQuizDragDrop from "../AscAddActivitiesVariants/AscActivityQuizDragDrop/AscActivityQuizDragDrop";

import styles from "./AscActivitiesFactory.module.scss";
import { ActivityTypeSelectOptions } from "@ascendnow/shared";

export interface AscActivitiesFactoryProps {
  className?: string;
  type: ActivityTypeSelectOptions["value"];
}

export default function AscActivitiesFactory({
  className,
  type,
}: AscActivitiesFactoryProps) {
  const variant = useMemo(() => {
    switch (type) {
      case "dragDrop":
        return <AscActivityDragDrop />;
      case "essay":
        return <AscActivityEssay />;
      case "crossword":
        return <AscActivityCrossword />;
      case "findWord":
        return <AscActivityFindWords />;
      case "flashcards":
        return <AscActivityFlashcards />;
      case "timeline":
        return <AscActivityTimeline />;
      case "trueFalse":
        return <AscActivityTrueFalse />;
      case "markWord":
        return <AscActivityMarkWord />;
      case "dragWord":
        return <AscActivityDragWord />;
      case "quiz":
        return <AscActivityQuiz />;
      case "quizDragDrop":
        return <AscActivityQuizDragDrop />;
      case "assessment":
        return <AscActivityAssessment />;
      default:
        return null;
    }
  }, [type]);

  return (
    <div
      data-testid="asc-activities-factory"
      className={classNames(styles.ground, className)}
    >
      {variant}
    </div>
  );
}
